import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { useFullDestination } from '@jane/bloom/hooks/navigation/useFullDestination';

export function useNavigateWithBasename() {
  const navigate = useNavigate();
  const generatePath = useFullDestination();

  return useCallback(
    (to: string) => {
      return navigate(generatePath(to));
    },
    [navigate, generatePath]
  );
}
